import { dateFormattedOrDash } from '@klear/order-event/list-display'
import type { OrderEventFeeCollection } from '@klear/order-event/order-event-timeline-tree'
import { Badge } from '@klear/ui/components/badge'

export function FeeCollectionRow({ fc }: { fc: OrderEventFeeCollection }) {
  return (
    <div className="flex items-center gap-2">
      <Badge variant="secondary">Fee collection</Badge>
      <span className="font-medium">{dateFormattedOrDash(fc.effectiveDate)}</span>
      <span className="text-sm text-muted-foreground">{fc.amount.toString()}</span>
      {fc.status ? <span className="text-xs text-muted-foreground capitalize">{fc.status}</span> : null}
    </div>
  )
}
